import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var ProjectTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(ProjectTransformer, _BaseTransformer);
  var _super = _createSuper(ProjectTransformer);
  function ProjectTransformer() {
    _classCallCheck(this, ProjectTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(ProjectTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        avatarType: data.avatar_type,
        projectColor: data.project_color,
        avatarIcon: data.avatar_icon,
        avatarImage: data.avatar_image,
        accountName: data.account_name,
        projectName: data.project_name,
        projectStatus: data.project_status,
        projectGroup: data.project_group,
        startDate: data.start_date,
        dueDate: data.due_date,
        followUpOn: data.follow_up_on,
        recordOwner: data.record_owner,
        team: data.team,
        completedTaskRate: data.completed_tasks_rate,
        openTasks: data.open_tasks,
        openTaskAssignees: data.open_task_assignees,
        openTaskDuration: data.open_task_duration,
        overdueTasks: data.overdue_tasks,
        overdueTaskAssignees: data.overdue_task_assignees,
        overdueTaskDuration: data.overdue_task_duration,
        dependentTaskAssignees: data.dependent_task_assignees,
        dependentTaskDuration: data.dependent_task_duration,
        lastUpdateDate: data.last_update_date,
        lastUpdateMessage: data.last_update_message,
        createdOn: data.created_on,
        createdBy: data.created_by,
        lastModifiedOn: data.last_modified_on,
        lastModifiedBy: data.last_modified_by,
        approval_required: data.approval_required,
        section_required: data.section_required,
        use_sections: data.use_sections,
        use_threads: data.use_threads,
        recordId: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return ProjectTransformer;
}(BaseTransformer);